import { render, staticRenderFns } from "./PrivacyPolicyButton.vue?vue&type=template&id=4133ea81&"
import script from "./PrivacyPolicyButton.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports